import { RENTAL_PORTAL_VIEWING_STATUSES } from '../../../../../../constants/rentalPortal'
import { EntityStatus } from '../../../../../Entity'
import {
  getIsViewingOpenSlot,
  getListingViewingTimeRangeLabel,
  RentalPortalViewingDateCell,
} from '../../../../../RentalPortalViewing'
import {
  TableCellBase,
  TableEmptyCell,
  TableTextCell,
} from '../../../../../Table'
import { ListingViewingColumnName } from '../RentalPortalListingProfileViewings.constants'
import { getListingViewingApplicantLabel } from '../RentalPortalListingProfileViewings.utils'

export function renderListingProfileViewingsCell({
  item,
  locale,
  name,
  timezone,
  ...restProps
}) {
  const { [name]: value } = item

  switch (name) {
    case ListingViewingColumnName.DateTime:
      return value ? (
        <RentalPortalViewingDateCell
          {...restProps}
          isFreeSlot={getIsViewingOpenSlot(item)}
          locale={locale}
          start={value}
          timeLabel={getListingViewingTimeRangeLabel({
            end: item.end,
            locale,
            start: item.start,
            timezone,
          })}
          timezone={timezone}
        />
      ) : (
        <TableEmptyCell {...restProps} />
      )

    case ListingViewingColumnName.Applicant:
      return (
        <TableTextCell
          {...restProps}
          value={getListingViewingApplicantLabel(item)}
        />
      )

    case ListingViewingColumnName.Status:
      return RENTAL_PORTAL_VIEWING_STATUSES[value] ? (
        <TableCellBase {...restProps}>
          <EntityStatus id={value} statuses={RENTAL_PORTAL_VIEWING_STATUSES} />
        </TableCellBase>
      ) : (
        <TableEmptyCell {...restProps} />
      )

    default:
      return <TableEmptyCell {...restProps} />
  }
}
